export default __webpack_public_path__ + "static/media/gooutimg.78e68eaa.png";